export const PRODUCT_LIST_WHATSAPP_PHONE = "2348098892157";
export const SINGLE_PRODUCT_WHATSAPP_PHONE = "2348067320283";

export const getProductUrl = (product) => {
  if (!product) {
    return window.location.origin || "";
  }

  const productId = product._id || product.id;
  return `${window.location.origin}/single/${productId}`;
};

export const buildWhatsAppMessage = (product, deliveryInfo = {}) => {
  const cleaned = {
    customerName: (deliveryInfo.customerName || "").trim(),
    phoneNumber: (deliveryInfo.phoneNumber || "").trim(),
    country: (deliveryInfo.country || "").trim(),
    state: (deliveryInfo.state || "").trim(),
    city: (deliveryInfo.city || "").trim(),
    address: (deliveryInfo.address || "").trim(),
    instructions: (deliveryInfo.instructions || "").trim(),
  };

  const price =
    typeof product?.price === "number"
      ? product.price
      : Number(product?.price || 0);

  const productName = product?.name || "Unknown Product";
  const productLink = getProductUrl(product);

  return [
    "Hello, I would like to order this product.",
    "",
    `Product: ${productName}`,
    `Price: $${price}`,
    `Product Link: ${productLink}`,
    "",
    "Customer Details:",
    `Name: ${cleaned.customerName}`,
    `Phone: ${cleaned.phoneNumber}`,
    "",
    "Delivery Details:",
    `Country: ${cleaned.country}`,
    `State: ${cleaned.state}`,
    `City: ${cleaned.city}`,
    `Address: ${cleaned.address}`,
    `Additional Instructions: ${cleaned.instructions || "None"}`,
    "",
    "Please confirm availability and delivery details.",
  ].join("\n");
};

export const openWhatsAppOrder = (product, deliveryInfo, phoneNumber) => {
  const message = buildWhatsAppMessage(product, deliveryInfo);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, "_blank");
};
